import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../../../helpers/export'
import ScoreCompanyService from '../../../../../core/service'

export const getLinkageScoreThunk = createAsyncThunk(
  'score/corporateRiskScore/getLinkageScoreThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getLinkageScore(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const downloadLinkageScore = createAsyncThunk(
  'score/corporateRiskScore/downloadLinkageScore',
  async (params) => {
    try {
      const res = await ScoreCompanyService.downloadLinkageScore(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
